import * as React from 'react';
import Config from '../config';
import locales from '../locales';
import {Layout, Modal} from 'antd';

import './AppFooter.css';

import logoDip from '../assets/logo-dip.png';
import logoDip2x from '../assets/logo-dip@2x.png';
import ReleaseNotes from './ReleaseNotes';
import {now} from "../utils/date-utils";

const {Footer} = Layout;

interface State {
  releaseNotesVisible: boolean;
}

class AppFooter extends React.Component<{}, State> {

  public state: State = {releaseNotesVisible: false};

  public render(): React.ReactNode {
    const {releaseNotesVisible} = this.state;
    return (
      <>
        <Modal
          visible={releaseNotesVisible}
          footer={null}
          onCancel={this.onReleaseNotesDismiss}
          destroyOnClose={true}
        >
          <ReleaseNotes/>
        </Modal>

        <Footer className="app-footer">
          <div className="left">
            <div className="version">
              <p>{locales.version} {Config.getAppVersion()}</p>
            </div>
            <p><a onClick={this.onShowReleaseNotesClick}>{locales.release_notes}</a></p>
          </div>
          <div className="center">
            <p>{locales.footerCopyRight(now().year())}</p>
          </div>
          <div className="right">
            <a href="http://www.wearedip.eu" target="_blank">
              <p style={{display: "inline"}}>powered by</p>
              <img
                style={{marginLeft: 6, marginTop: 2}}
                alt="dip logo"
                src={logoDip}
                srcSet={`${logoDip}, ${logoDip2x} 2x`}
              />
            </a>
          </div>
        </Footer>
      </>
    );
  }

  private onShowReleaseNotesClick = () => {
    this.setState({releaseNotesVisible: true});
  };

  private onReleaseNotesDismiss = () => {
    this.setState({releaseNotesVisible: false});
  };
}

export default AppFooter;


// WEBPACK FOOTER //
// ./src/app/AppFooter.tsx